import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface Comunidad {
  identifier: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class ComunidadService {
  private jsonUrl = 'assets/data/comunidadAutonoma.json'; 

  constructor(private http: HttpClient) {}

  getComunidades(): Observable<Comunidad[]> {
    return this.http.get<Comunidad[]>(this.jsonUrl);
  }
}
